<div class="w-auto card-filter-matrix">
   <div class="filters">
    <button id="origin" (click)="selectTypeMatrix('origin')" class="button-filter active">Origen</button>
    <button id="destination" (click)="selectTypeMatrix('destination')" class="button-filter">Destino</button>
   </div>
   <div class="content-percentage">
     <span *ngFor="let item of SelectedFilterOptions;" [ngClass]="{'active' : ExitsOnArray(item)}" id="{{item}}" (click)="selectPercentage(item)" class="selectedHover">{{item}}</span>
   </div>
    <div class="footer-buttons">
      <sit-button
      [buttonProperties]="restorebuttonAttributes"
      (click)="sendValues(true);"
        class="mr-05-em special-btn"
        style=""
      ></sit-button>

      <sit-button
      [buttonProperties]="applybuttonAttributes"
      (click)="sendValues(false)"
      ></sit-button>
    </div>
</div>
